import { inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { environment } from '../../environments/environment';

export interface UserProfile {
  name: string;
  email: string;
  initials: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private msalService = inject(MsalService, { optional: true });

  get isAuthenticated(): boolean {
    if (!environment.useMsal) return true;
    return (this.msalService?.instance.getAllAccounts().length ?? 0) > 0;
  }

  get activeAccount(): AccountInfo | null {
    if (!environment.useMsal || !this.msalService) return null;
    return (
      this.msalService.instance.getActiveAccount() ??
      this.msalService.instance.getAllAccounts()[0] ??
      null
    );
  }

  get userProfile(): UserProfile | null {
    const account = this.activeAccount;
    if (!account) {
      if (!environment.useMsal) {
        return { name: 'Local Dev User', email: 'dev@local', initials: 'LD' };
      }
      return null;
    }
    const name = account.name ?? account.username ?? 'User';
    const email = account.username ?? '';
    const parts = name.trim().split(' ');
    const initials =
      parts.length >= 2
        ? `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
        : name.substring(0, 2).toUpperCase();
    return { name, email, initials };
  }

  logout(): void {
    if (!environment.useMsal || !this.msalService) return;
    // Redirect to /login after sign-out (was '/' before — bug fix)
    this.msalService.logoutRedirect({ postLogoutRedirectUri: '/login' });
  }
}
